module.exports = __webpack_public_path__ + "static/media/love.c0a77e55.png";